import React from 'react';
import { connect } from 'unistore/react';

import { Button } from '.';

import {
	actionsCombiner,
	modalActions,
	monitorActions,
} from '@utils/store/actions';

class YoutubeBtn extends React.PureComponent {
	openYoutube = () => {
		const {
			__youtubeModal,
			modalText,
			videoId,
			onClick,
			__pushToMonitorEvents,
			start,
		} = this.props;

		__youtubeModal(modalText, videoId, start);
		__pushToMonitorEvents('Youtube Button', {
			action: 'Clicked to Watch',
		});
		if (typeof onClick === 'function') {
			onClick();
		}
	};

	render() {
		const {
			className,
			size,
			iconOnly,
			text,
			btnProps = {
				variant: 'minimal',
			},
		} = this.props;

		return (
			<Button
				{...btnProps}
				onClick={this.openYoutube}
				className={`flex text-left items-start ${className || ''}`}
				size={size || 'small'}
			>
				<div className="mr-2 u-text--singleLine text-redLighter">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						data-name="Layer 1"
						height="13"
						className="-mt-1 inline-block align-middle"
						viewBox="0 0 24 24"
					>
						<path
							fill="#ff5746"
							d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zM9.6 17.4V6.6l7.2 5.4z"
						/>
					</svg>{' '}
					{!iconOnly && text ? 'Watch:' : 'Watch Now'}
				</div>{' '}
				{text}
			</Button>
		);
	}
}

export default connect(
	'',
	actionsCombiner(modalActions, monitorActions)
)(YoutubeBtn);
